import { CartAddEvent } from '@theme/events';

const dialog = document.getElementById('cbn-quick-dialog');
if (dialog) {
  const body = dialog.querySelector('.cbn-quick-body');
  const status = dialog.querySelector('.cbn-quick-status');
  const details = dialog.querySelector('.cbn-quick-details');
  let opener;
  let controller;
  let variants = [];
  let pending = false;
  let root;
  let compareOpener;

  function closeComparison() {
    const panel = root?.querySelector('.cbn-quick-comparison');
    if (!panel) return false;
    panel.remove();
    dialog.classList.remove('is-comparing');
    root.querySelector('form').hidden = false;
    compareOpener?.setAttribute('aria-expanded', 'false');
    compareOpener?.focus({ preventScroll: true });
    body.scrollTop = 0;
    return true;
  }

  dialog.addEventListener('click', event => {
    const help = event.target.closest('[data-cbn-compare]');
    const choose = event.target.closest('[data-cbn-compare-select]');
    if (help && root) {
      compareOpener = help;
      const template = root.querySelector(`[data-cbn-compare-template="${help.dataset.cbnCompare}"]`);
      if (!template) return;
      root.querySelector('form').hidden = true;
      root.append(template.content.cloneNode(true));
      dialog.classList.add('is-comparing');
      help.setAttribute('aria-expanded', 'true');
      body.scrollTop = 0;
      root.querySelector('.cbn-quick-comparison h3').focus({ preventScroll: true });
    } else if (choose && root) {
      const group = root.querySelector(`[data-option-index="${choose.dataset.cbnCompareSelect}"]`);
      const input = [...group.querySelectorAll('input')].find(item => item.value === choose.dataset.value);
      if (input) { input.checked = true; updateVariant(); }
      closeComparison();
    } else if (event.target.closest('[data-cbn-compare-back]')) closeComparison();
  });

  function updateVariant() {
    if (!root) return;
    const choices = [...root.querySelectorAll('fieldset')].map(group => group.querySelector('input:checked')?.value);
    const variant = variants.find(item => choices.length === 0 || item.options.every((value, i) => value === choices[i]));
    const form = root.querySelector('form');
    if (!form) return;
    form.elements.id.value = variant?.id || '';
    form.elements.quantity.value = variant?.quantity || 1;
    root.querySelector('.cbn-quick-price').textContent = variant?.price || root.dataset.unavailable;
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = pending || !variant?.available;
    submit.textContent = pending ? root.dataset.adding : !variant ? root.dataset.unavailable : variant.available ? root.dataset.add : root.dataset.soldOut;
    if (variant) {
      const url = new URL(details.href);
      url.searchParams.set('variant', variant.id);
      details.href = url.href;
    }
  }

  function close() {
    if (pending) return;
    controller?.abort();
    dialog.close();
  }

  dialog.querySelector('.cbn-quick-close').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { if (pending || closeComparison()) event.preventDefault(); });
  dialog.addEventListener('close', () => {
    controller?.abort();
    opener?.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('change', () => { status.textContent = ''; updateVariant(); });

  document.addEventListener('click', async event => {
    const trigger = event.target.closest?.('[data-cbn-quick-url]');
    if (!trigger || trigger.disabled || pending) return;
    event.preventDefault();
    opener = trigger;
    controller?.abort();
    controller = new AbortController();
    const request = controller;
    root = null;
    variants = [];
    body.replaceChildren();
    dialog.classList.remove('is-comparing');
    const optionCount = Math.max(1, Math.min(3, Number(trigger.dataset.cbnQuickOptions) || 2));
    const dialogHeight = 320 + optionCount * 80;
    dialog.style.setProperty('--cbn-quick-height', `${dialogHeight}px`);
    body.setAttribute('aria-busy', 'true');
    status.textContent = dialog.dataset.loading;
    document.getElementById('cbn-quick-title').textContent = trigger.dataset.title;
    const url = new URL(trigger.dataset.cbnQuickUrl, location.origin);
    details.href = url.href;
    const rect = trigger.getBoundingClientRect();
    dialog.style.setProperty('--cbn-quick-left', `${Math.max(12, Math.min(rect.right - 420, innerWidth - 432))}px`);
    dialog.style.setProperty('--cbn-quick-top', `${Math.max(16, Math.min(rect.top, innerHeight - dialogHeight - 16))}px`);
    dialog.showModal();
    url.searchParams.set('section_id', 'cbn-quick-product');
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error('Options unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fragment = html.querySelector('[data-cbn-quick-product]');
      if (!fragment) throw new Error('Options unavailable');
      const data = fragment.querySelector('[data-cbn-quick-variants]');
      variants = data ? JSON.parse(data.textContent) : [];
      fragment.querySelectorAll('script').forEach(script => script.remove());
      if (request.signal.aborted || !dialog.open) return;
      root = document.importNode(fragment, true);
      body.replaceChildren(root);
      status.textContent = '';
      updateVariant();
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = dialog.dataset.error;
    } finally {
      if (controller === request) body.removeAttribute('aria-busy');
    }
  });

  dialog.addEventListener('submit', async event => {
    event.preventDefault();
    const form = event.target;
    if (pending || !form.elements.id?.value || form.querySelector('[type="submit"]').disabled) return;
    pending = true;
    updateVariant();
    status.textContent = root.dataset.adding;
    const formData = new FormData(form);
    [...formData.keys()].filter(key => key.startsWith('cbn-option-')).forEach(key => formData.delete(key));
    const sections = [...new Set([...document.querySelectorAll('cart-drawer-component[data-section-id], cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    if (sections.length) formData.set('sections', sections.join(','));
    formData.set('sections_url', location.pathname);
    root.querySelectorAll('input[type="radio"]').forEach(input => { input.disabled = true; });
    dialog.querySelector('.cbn-quick-close').disabled = true;
    let added = false;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', signal: AbortSignal.timeout(20000), body: formData, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || dialog.dataset.error);
      added = true;
      pending = false;
      dialog.close();
      document.dispatchEvent(new CartAddEvent({}, String(formData.get('id')), { source: 'product-form-component', productId: root.dataset.productId, variantId: String(formData.get('id')), itemCount: Number(formData.get('quantity')), sections: result.sections }));
    } catch (error) {
      status.textContent = added ? root.dataset.added : (error.name === 'TypeError' || error.name === 'TimeoutError') ? root.dataset.network : error.message || dialog.dataset.error;
    } finally {
      pending = false;
      dialog.querySelector('.cbn-quick-close').disabled = false;
      root.querySelectorAll('input[type="radio"]').forEach(input => { input.disabled = false; });
      updateVariant();
    }
  });
}
